import { Button, Space, Table, Tag, Input, DatePicker, Checkbox, Form, Select, message } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import React, { useEffect, useState } from 'react';
import { getUsers, getUserInfor, updateMeals, addMeals } from '../../service/auth/AuthService';
import { getToken } from '../../helper/tokenHelper';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

import './OrderCreate.scss';

interface DataType {
	key: string;
	name: string;
	age: number;
	address: string;
	tags: string[];
}

export default function Order() {
	const dateFormat = 'YYYY/MM/DD';
	const [usersCompany, getUsersCompany] = useState<any[]>([]);
	const [idUserInformation, getIDUserInformation] = useState<number>(0);
	const [formCreate] = Form.useForm();

	const { Option } = Select;
	const navigate = useNavigate();

	useEffect(() => {
		getUsers()
			.then((res: any) => {
				console.log(res);
				getUsersCompany(res.data.data);
			})
			.catch((err: any) => {
				console.log(err);
			});
		getUserInfor()
			.then((res: any) => {
				console.log(res);
				getIDUserInformation(res.data.data.id);
			})
			.catch((err: any) => {
				console.log(err);
			});
	}, []);

	const onFinish = (values: any) => {
		console.log('Success:', values);
		let created = values.created;
		if(created) {
			created  = new Date(moment(values.created).format('YYYY-MM-DD')).toISOString()
		} else {
			created = new Date().toISOString()
		}
		const paramsCreate = {
			shoplink: values.shoplink,
			shopprice: 0,
			totalneed2pay: 0,
			creator: idUserInformation,
			payer: values.payer,
			status: 'new',
			created: created,
			modified: new Date().toISOString(),
		};
		// return;
		addMeals(paramsCreate)
			.then((res: any) => {
				console.log(res);
				message.success('Bạn đã tạo bữa ăn thành công');
				formCreate.setFieldsValue({
					shoplink: '',
					payer: '',
				});
				navigate('/home');
			})
			.catch((err: any) => {
				console.log(err);
				message.error(err.response.data.detail);
			});
	};

	const onFinishFailed = (errorInfo: any) => {
		console.log('Failed:', errorInfo);
	};

	return (
		<div className="text-center text-base ">
			<h1 className="my-5 text-lg">Bữa ăn</h1>
			<div className="w-full mx-auto border border-gray-500 p-5 rounded-md form-order">
				<Form
					name="basic"
					labelCol={{ span: 4 }}
					wrapperCol={{ span: 32 }}
					initialValues={{ remember: true }}
					onFinish={onFinish}
					onFinishFailed={onFinishFailed}
					autoComplete="off"
					form={formCreate}
				>
					<Form.Item
						label="Tên cửa hàng"
						name="shoplink"
						rules={[{ required: true, message: 'Please input your shop!' }]}
					>
						<Input />
					</Form.Item>

					<Form.Item
						label="Người trả"
						name="payer"
						rules={[{ required: true, message: 'Please input your payer!' }]}
					>
						<Select>
							{usersCompany.map((item: any, index) => {
								return (
									<>
										<Option value={item.id}>{item.fullname}</Option>
									</>
								);
							})}
						</Select>
					</Form.Item>
					<Form.Item
							label="Ngày tạo"
							name="created"
							// className="input-shop"
						>
							<DatePicker
								className="w-[100%] "
								value={moment(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()))}
								defaultValue={moment(
									moment(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())),
									dateFormat,
								)}
								format={dateFormat}
							/>
					</Form.Item>
					<Form.Item wrapperCol={{ offset: 8, span: 32 }} className="button-submit">
						<Button type="primary" htmlType="submit">
							Tạo bữa ăn
						</Button>
					</Form.Item>
				</Form>
			</div>
		</div>
	);
}
